import { useRef, useState, type CSSProperties, type ReactNode } from 'react';

import { Text, Tooltip, Icon } from '@sso/shared/core';
import { useResize } from '@sso/shared/hooks';
import { boxed } from '@sso/shared/hocs';

import { Container, Content, Caption } from './Section.styles';

export type SectionProps = {
    style?: CSSProperties;
    skeleton?: ReactNode;
    children: ReactNode;
    description?: string;
    isLoading?: boolean;
    tooltip?: string;
    title: string;
};

function Section({
    description,
    isLoading,
    children,
    skeleton,
    tooltip,
    title,
    ...props
}: SectionProps) {
    const [column, setColumn] = useState(false);

    const ref = useRef(null);

    useResize(ref, rect => setColumn(rect.width < 848));

    return (
        <Container ref={ref} $column={column}>
            <Caption>
                <Text color="neutral.title" weight="semiBold" size="displaySm" wide>
                    {title}
                    {tooltip && ' '}
                    {tooltip && (
                        <Tooltip trigger={<Icon name="help" />} placement="top">
                            {tooltip}
                        </Tooltip>
                    )}
                </Text>
                {description && (
                    <Text color="neutral.subtitle" size="textMd" wide>
                        {description}
                    </Text>
                )}
            </Caption>
            <Content wide maxWidth={512} {...props}>
                {isLoading ? skeleton : children}
            </Content>
        </Container>
    );
}

export default boxed(Section);
